module.exports = __webpack_public_path__ + "static/img/8ffa32a.dccee4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/8ffa32a.png
// module id = d0Gn
// module chunks = 1